import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AngularFireMessaging } from '@angular/fire/messaging';


@Injectable({
  providedIn: 'root'
})
export class MessagingService {

  currentMessage = new BehaviorSubject(null);

  constructor(private angularFireMessaging: AngularFireMessaging) {
    this.angularFireMessaging.messages
      .subscribe((message) => { console.log(message); });

  }

  requestPermission() {
    this.angularFireMessaging.requestToken
      .subscribe(
        (token) => {
          // console.log('Permission granted! Save to the server!', token);
          localStorage.setItem('deviceid', token)
        },
        (error) => { console.error(error); },
      );
  }

  receiveMessage() {
    this.angularFireMessaging.messages.subscribe(
      (msg) => {
        console.log("show message!", msg);
        this.currentMessage.next(msg);
      })
  }
}
